import React, { Component } from "react";
import { Link } from "react-router-dom";
import app from "../base";

class ShowRentals extends Component {
  constructor(props) {
    super(props);
    this.ref = app.firestore().collection("rentals");
    this.unsubscribe = null;
    this.state = {
      rentals: [],
    };
  }

  onCollectionUpdate = (querySnapshot) => {
    const rentals = [];
    querySnapshot.forEach((doc) => {
      const {
        rental_name,
        owner,
        address,
        phone,
        email,
        location,
      } = doc.data();
      rentals.push({
        key: doc.id,
        doc, // DocumentSnapshot
        rental_name,
        owner,
        address,
        phone,
        email,
        location,
      });
    });
    this.setState({
      rentals,
    });
  };

  componentDidMount() {
    this.unsubscribe = this.ref.onSnapshot(this.onCollectionUpdate);
  }

  render() {
    return (
      <table class="table table-stripe">
        <thead>
          <tr>
            <th>Rental Name</th>
            <th>Owner</th>
            <th>Address</th>
          </tr>
        </thead>
        <tbody>
          {this.state.rentals.map((rental) => (
            <tr>
              <td>
                <Link to={`/admin/show/${rental.key}`}>{rental.rental_name}</Link>
              </td>
              <td>{rental.owner}</td>
              <td>{rental.address}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}

export default ShowRentals;
